import { RootState } from '..';

export const selectDefaultFolderId = (state: RootState) =>
    state.defaultFolder.id;

export const selectDefaultFolderPath = (state: RootState) =>
    state.defaultFolder.path;

export const selectDefaultFolderScope = (state: RootState) =>
    state.defaultFolder.scope;

export const selectDefaultFolderLoaded = (state: RootState) =>
    state.defaultFolder.isDefaultFolderLoaded;

export const selectDefaultFolderModalStep = (state: RootState) =>
    state.defaultFolder.defaultFolderFormData.defaultFolderModalStep;

export const selectFormDefaultFolderId = (state: RootState) =>
    state.defaultFolder.defaultFolderFormData.id;

export const selectFormDefaultFolderPath = (state: RootState) =>
    state.defaultFolder.defaultFolderFormData.path;

export const selectFormDefaultFolderScope = (state: RootState) =>
    state.defaultFolder.defaultFolderFormData.scope;

export const selectFormDefaultFolderCircle = (state: RootState) =>
    state.defaultFolder.defaultFolderFormData.circle;

export const selectSharedCircle = (state: RootState) =>
    state.defaultFolder.sharedCircle;
